<script>
import config from "../../config";
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import pagination from "laravel-vue-pagination";
import moment from "moment";
import { driverService, deliveryZoneService } from "../../services";
import { base64, debounce,error_message, success_message } from "../../Helper/helper";

export default {
  components: { Layout, PageHeader, pagination, moment },
  data() {
    const { status, country, state, city, orderBy, sortBy } = this.$route.query;
    return {
      sortBy: sortBy || "createddate",
      sortDesc: orderBy && orderBy != "" ? true : orderBy,
      drivers: [],
      driverData: [],
      driverCount: "",
      paginations: {},
      limit: 2,
      search: "",
      status: status == undefined ? "0" : status,
      config: config,
      moment: moment,
      countries: [],
      states: [],
      cities: [],
      country: country || 0,
      state: state || 0,
      city: city || 0,
      loading: true,
      init: true,
      isDownloading: false,
      searchData: debounce(() => {
        if (!this.init) {
          const { status, country, state, city, orderBy, sortBy } = this.$data;
          this.$router.replace({
            name: "driver-list",
            query: { status, country, state, city, orderBy, sortBy },
          });
        }
        this.getDriver();
        this.init = false;
      }, 500),
      fields: [
        { key: "profileimage", label: "#", sortable: false,thClass:"dis-event" },
        {
          key: "firstname",
          label: this.trans.get("__JSON__.Name"),
          sortable: true,
        },
        {
          key: "email",
          label: this.trans.get("__JSON__.Email"),
          sortable: true,
        },
        {
          key: "contactno",
          label: this.trans.get("__JSON__.Phone Number"),
          sortable: true,
        },
        // {
        //   key: "last_name",
        //   label: this.trans.get("__JSON__.Delivery Zone"),
        //   sortable: false,
        // },
        {
          key: "order_count",
          label: this.trans.get("__JSON__.Orders"),
          sortable: true,
        },
        {
          key: "is_block",
          label: this.trans.get("__JSON__.Status"),
          sortable: false,
          thClass:"dis-event"
        },
        {
          key: "availbility_status",
          label: this.trans.get("__JSON__.Available Status"),
          sortable: false,
          thClass:"dis-event"
        },
        {
          key: "customer_type",
          label: this.trans.get("__JSON__.Customer Type"),
          sortable: false,
          thClass:"dis-event"
        },
        {
          key: "action",
          label: this.trans.get("__JSON__.Action"),
          sortable: false,
          thClass:"dis-event"
        },
      ],
    };
  },
  computed: {
    filteredFields() {
      return this.fields.filter(field => {
        if (field.key === 'availbility_status') {
          // Determine if 'availbility_status' should be included based on your condition
          return this.drivers.some(driver => driver.is_block === '0');
        }
        // Always include other fields
        return true;
      });
    }
  },
  mounted() {
    //this.getVendorCountry();
    this.getDriver();
  },
  methods: {
    onRowClicked(item) {
      this.$router.push({
        name: "driver-details",
        params: { driver_id: this.base64(item.driverid) },
      });
    },
    downloadsCSV: function () {
      let driverData =
        "\ufeff" +
        "First Name ("+this.$auth.langauges[0].name+"),Last Name ("+this.$auth.langauges[0].name+"),First Name ("+this.$auth.langauges[1].name+"),Last Name ("+this.$auth.langauges[1].name+"),Email,Phone Number,Alternate Phone Number,Delivery Zone,Full Address,Vehicle Type,Vehicle Number,Licence Number,Order,Availbility Status\n";
      this.driverData.forEach((el) => {
        var line =
          el["firstname"] +
          "," +
          el["lastname"] +
          "," +
          (el["firstname_other_lang"] ? el["firstname_other_lang"] : "-").replaceAll("null","-") + 
          "," +
          (el["lastname_other_lang"] ? el["lastname_other_lang"] : "-").replaceAll("null","-") +
          "," +
          el["email"] +
          "," +
          el["contactno"] +
          "," +
          (el["alternate_contactno"] ? el["alternate_contactno"] : "-").replaceAll("null","-") +
          "," +
          (el["zone"] ? el["zone"] : "-").replaceAll("null","-") +
          "," +
          (el["address"] ? el["address"] : "-").replaceAll(",", " ") +
          "," +
          el["vehicle_type"] +
          "," +
          (el["vehicle_number"] ? el["vehicle_number"] : "-").replaceAll("null","-") +
          "," +
          (el["licence_number"] ? el["licence_number"] : "-").replaceAll("null","-") +
          "," +
          el["order_count"] +
          "," +
          (el["is_block"] == 0 ? "Active" : el["is_block"] == 1 ? "Inactive" : "Waiting For Approval") +
          "\n";
        driverData += line;
      });

      var blob = new Blob([driverData], { type: "csv/plain" });
      var date = new Date().toLocaleString();
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = this.$auth.setting.driver_name + "_" + date + ".csv";
      link.click();
    },
    getDriver(page) {
      this.loading = true;
      // if (this.sortBy == "firstname") {
      //   this.sortDesc = false;
      // } else {
      //   this.sortDesc = true;
      // }
      var filters = {
        search: this.search,
        status: this.status,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "desc" : "asc",
        country: this.country,
        state: this.state,
        city: this.city,
        page: page && page > 0 ? page : 1,
      };
      driverService.getDriver(filters).then((response) => {
        this.loading = false;
        this.paginations = response.data.result.data;
        this.drivers = response.data.result.data.data;
        this.driverCount = response.data.result.drivercount;
      });
    },
    driverExportCsv() {
      this.isDownloading =true;
      driverService
        .driverExportCsv({
          status: this.status,
          sortBy: this.sortBy,
          orderBy: this.sortDesc ? "desc" : "asc",
        })
        .then((response) => {
          this.isDownloading =false;
          this.driverData = response.data.result.data;
          this.downloadsCSV();
        });
    },
   getVendorCountry() {
      this.country = 0;
      this.city = 0;
      this.state = 0;
      this.countries = [];
      this.states = [];
      this.cities = [];
      deliveryZoneService.getVendorCountry().then((response) => {
        this.countries = response.data.result;
        if (this.countries.length == 1) {
          this.country = this.countries[0].id;
        }
        this.getVendorState();
      });
    },
   getVendorState() {
      this.city = 0;
      this.state = 0;
      this.states = [];
      this.cities = [];
      this.country = parseInt(this.country);
      if(this.country > 0) {
        deliveryZoneService.getVendorState({country_id: this.country})
        .then((response) => {
          this.states = response.data.result;
          if (this.states.length == 1) {
            this.state = this.states[0].id;
          }
          this.getVendorCity();
        });
      } else {
        this.searchData();
      }
    },
    getVendorCity() {
      this.city = 0;
      this.cities = [];
      this.state = parseInt(this.state);
      if(this.state > 0) {
        deliveryZoneService.getVendorCity({state_id:this.state ? this.state : 0,country_id: this.country})
        .then((response) => {
          this.cities = response.data.result;
          if (this.cities.length == 1) {
            this.city = this.cities[0].cityid;
          }
          this.searchData();
        });
      } else {
        this.searchData();
      }
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getDriver();
    },
    deleteById(driver_id){
      if (confirm("Are you sure you want to delete?")) {
        driverService
          .deleteDriver({ driver_id: driver_id })
          .then((response) => {
            if (response.data.code === 200) {
              success_message(response.data.message);
              this.getDriver();
            } else {
              error_message(response.data.message);
            }
          });
      }
    },
    onStatusChange(driver_id, availbility_status){
      driverService.updateAvailbilityStatus({
        driver_id: driver_id,
        availbility_status: availbility_status
      }).then(response => {
        if(response.data.code == 200){
          success_message(response.data.message)
        }
      })
    }
  }
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left">
            <div class="avatar-xs mr-3">
              <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                <i class="bx bx-user"></i>
              </span>
            </div>
            <h4
              class="mb-0 font-size-18"
            >{{ trans.trans('__JSON__.Driver',{ driver: $auth.setting.driver_name }) }}({{driverCount}})</h4>
          </div>
          <div class="page-title-right d-flex">
            <router-link
              :to="{name: 'driver-add'}"
              class="btn btn-success btn-rounded mr-2 add-btn"
              v-if="$auth.hasPermission(config.permissions.driver_write)"
            >
              <i class="mdi mdi-plus mr-1"></i>
              {{ trans.trans('__JSON__.Add Delivery Boy',{ driver: $auth.setting.driver_name }) }}
            </router-link>
            <!-- <button
              @click="driverExportCsv"
              class="btn btn-primary btn-rounded export-btn"
               v-if="isDownloading"
              disabled
            >{{ trans.get('__JSON__.Exporting...') }}</button>
            <button
              @click="driverExportCsv"
              class="btn btn-primary btn-rounded export-btn"
              v-else
            >{{ trans.get('__JSON__.Export To CSV') }}</button> -->
            <div class="d-flex m-vendor-btn">
              <router-link
                :to="{name: 'driver-add'}"
                class="btn btn-success btn-rounded mr-2 m-add-btn"
                v-if="$auth.hasPermission(config.permissions.driver_write)"
              >
                <i class="mdi mdi-plus"></i>
              </router-link>
              <button @click="driverExportCsv" class="btn btn-primary btn-rounded m-export-btn">
                <i class="bx bx-archive-in"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row list-table-main">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div v-if="countries.length >1" class="col-sm-2">
                <div class="form-group">
                  <div class="date-range-list">
                    <label>{{ trans.get('__JSON__.Country') }} :</label>
                    <select class="custom-select" v-model="country" @change="getVendorState">
                      <option value="0" selected>{{ trans.get('__JSON__.All') }}</option>
                      <option
                        v-for="con in countries"
                        :value="con.id"
                        :key="con.id"
                      >{{con.country_name}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div v-else class="col-sm-2"></div>
              <div v-if="states.length >1" class="col-sm-2">
                <div class="form-group">
                  <div class="date-range-list">
                    <label>{{ trans.get('__JSON__.State') }} :</label>
                    <select class="custom-select" v-model="state" @change="getVendorCity">
                      <option value="0" selected>{{ trans.get('__JSON__.All') }}</option>
                      <option v-for="sat in states" :value="sat.id" :key="sat.id">{{sat.state_name}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div v-else class="col-sm-2"></div>
              <div v-if="cities.length >1" class="col-sm-2">
                <div class="form-group">
                  <div class="date-range-list">
                    <label>{{ trans.get('__JSON__.City') }} :</label>
                    <select class="custom-select" v-model="city" @change="searchData">
                      <option value="0" selected>{{ trans.get('__JSON__.All') }}</option>
                      <option
                        v-for="cit in cities"
                        :value="cit.cityid"
                        :key="cit.cityid"
                      >{{cit.cityname}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div v-else class="col-sm-2"></div>
              <div class="col-sm-2">
                <div class="form-group">
                  <div class="date-range-list">
                    <label>{{ trans.get('__JSON__.SortBy') }} :</label>
                    <select class="custom-select" v-model="sortBy" @change="searchData()">
                      <!-- <option value="status">{{ trans.get('__JSON__.Default') }}</option> -->
                      <option value="firstname">{{ trans.get('__JSON__.Alphabetically') }}</option>
                      <option value="createddate">{{ trans.get('__JSON__.Date Added') }}</option>
                      <option value="order_count">{{ trans.get('__JSON__.Most Orders') }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <div class="date-range-list">
                    <label>{{ trans.get('__JSON__.Status') }} :</label>
                    <select class="custom-select" v-model="status" @change="searchData()">
                      <option value>{{ trans.get('__JSON__.All') }}</option>
                      <option value="0" selected>{{ trans.get('__JSON__.Active') }}</option>
                      <option value="1">{{ trans.get('__JSON__.Inactive') }}</option>
                      <!-- <option value="2">{{ trans.get('__JSON__.Waiting For Approval') }}</option> -->
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="date-range-list">
                  <label>{{ trans.get('__JSON__.Search') }} :</label>
                  <div class="text-sm-right">
                    <div class="search-box mr-2 d-inline-block">
                      <div class="position-relative">
                        <input
                          type="text"
                          class="form-control"
                          id="search"
                          @input="searchData()"
                          v-model="search"
                          :placeholder="this.trans.get('__JSON__.Search')"
                        />
                        <i class="bx bx-search-alt search-icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 table-main-list driver-table table-responsive">
                <b-table
                  :items="drivers"
                  :fields="filteredFields"
                  :sort-by.sync="sortBy"
                  :no-local-sorting="true"
                  :sort-desc.sync="sortDesc"
                  @sort-changed="sortingChanged"
                  :busy="loading"
                  show-empty
                  @row-clicked="onRowClicked"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{trans.get('__JSON__.Loading...')}}</strong>
                    </div>
                  </template>
                  <template v-slot:cell(profileimage)="data">
                    <div v-if="data.item.profileimage">
                      <img
                        alt
                        title="product-img"
                        class="vendor-img avatar-xs"
                        :src="config.driver+data.item.profileimage"
                        @error="$event.target.src=config.basepath+'no-img.png'"
                      />
                        
                    </div>
                    <div v-else>
                      <img class="vendor-img avatar-xs" :src="config.basepath+'no-img.png'" alt />
                    </div>
                  </template>

                  <template v-slot:cell(firstname)="data">
                    <h5 class="font-size-14">{{data.item.firstname}} {{data.item.lastname}}</h5>
                  </template>

                  <!-- <template
                    v-slot:cell(last_name)="data"
                  >{{data.item.franchise?data.item.franchise.last_name:'-'}}</template> -->

                  <template v-slot:cell(is_block)="data">
                    <div
                      v-if="data.item.is_block == '0'"
                      class="badge badge-pill badge-soft-success font-size-12"
                    >{{ trans.get('__JSON__.Active') }}</div>
                    <div
                      v-if="data.item.is_block == '1'"
                      class="badge badge-pill badge-soft-danger font-size-12"
                    >{{ trans.get('__JSON__.Inactive') }}</div>
                    <div
                      v-if="data.item.is_block == '2'"
                      class="badge badge-pill badge-soft-warning font-size-12"
                    >{{ trans.get('__JSON__.Waiting For Approval') }}</div>
                  </template>

                  <template v-slot:cell(availbility_status)="data">
                    <div class="swtich-data">
                      <label class="switch">
                          <input
                          type="checkbox"
                          id="togBtn"
                          class="switch-on"
                          name="availbility_status"
                          v-model="data.item.availbility_status"
                          true-value="1"
                          false-value="0"
                          @change="onStatusChange(base64(data.item.driverid), data.item.availbility_status)"
                          />
                          <div class="slider round">
                            <span class="on">{{ trans.get('__JSON__.Yes') }}</span>
                            <span class="off">{{ trans.get('__JSON__.No') }}</span>
                          </div>
                      </label>
                    </div>
                  </template>


                  <template v-slot:cell(customer_type)="data">
                    <h5 class="font-size-14" v-if="data.item.customer_type == 1">Business</h5>
                    <h5 class="font-size-14" v-else>Private</h5>
                  </template>

                  <template v-slot:cell(action)="data">
                    <router-link
                      :to="{name: 'driver-details',params: { driver_id: base64(data.item.driverid) }}"
                      class="btn btn-primary btn-sm btn-rounded"
                    >{{ trans.get('__JSON__.View') }}</router-link>
                    <button
                      type="submit"
                      class="btn btn-danger btn-sm btn-rounded ml-1"
                      @click="deleteById(base64(data.item.driverid))"
                    >{{ trans.get('__JSON__.Delete') }}</button>
                  </template>

                  <template #empty>
                    <p class="text-center">{{ trans.get('__JSON__.No Driver Found') }}</p>
                  </template>
                </b-table>
              </div>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <pagination
                        :data="paginations"
                        :limit="limit"
                        @pagination-change-page="getDriver"
                      ></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>